
import { previewRequest } from 'link-previewer/client';
import {
  RECEIVE_MESSAGE,
  REMOVE_MESSAGE,
  REMOVE_MESSAGE_BY_ID,
  EDIT_MESSAGE_BY_ID,
  SEND_MESSAGE, ADD_PREVIEW_MESSAGE,
  TYPINGS_CHANGED,
  RECEIVE_CANNED_RESPONSE,
  updateRooms,
  receiveMessage,
  acceptCall,
  addPreviewMessage,
  sendMessage,
} from '../../actions/rooms'
import { SUBMIT_INPUT_AREA, MESSAGE_CHANGE, SEND_EDITED_MESSAGE, sendEditedMessage } from '../../actions/messages'
import { removeItem, removeItemByParam } from '../../../utils/immutable/array'
import { updateItemByPropertyName } from '../../../utils/immutable/objectArray'
import NetJsService from '../../../services/net/NetJsService'
import {
  createMessage, updateMessage, addMessage, regLink,
} from '../../../../../../../module/dev/room/message-display-area/messages/messageHelpers'
import parseCannedResponse from '../../../utils/canned-response/cannedResponse'
import { showBrowserNotification } from '../../actions/tools'
import { transformUnicode10to16 } from '../../../utils/common'
import { RoomStatuses } from '../../constants'
import findLinkOrEmail from '../../../../../../../module/dev/room/message-display-area/messages/utils/findLinkOrEmail'
import { MessageSubtypes } from '../../../../../../../module/dev/room/message-display-area/messages/constants'
import isLinkToFile from '../../../../../../../module/dev/libs/common/isLinkToFile'

const BLOCK_NOTIFICATION_TIMEOUT = 12000
export const textDisplayTemplate = ({ originalTextHtml, translatedTextHtml }) => {
  if (originalTextHtml && translatedTextHtml) {
    return `${originalTextHtml}<span class="line"></span>${translatedTextHtml}`
  }
  return translatedTextHtml || originalTextHtml
}

export const processReceiveMessage = ({ dispatch, getState }) => next => action => {
  next(action);

  if (action.type === RECEIVE_MESSAGE) {
    const { payload, meta: { roomId } } = action;
    const {
      rooms: { rooms, currentRoom },
      settings: { linkPreviewEnabled, notificationEnabled },
      texts: { texts },
      app: { lastTimeLogin },
    } = getState();
    const room = rooms.find(r => r.id === roomId);
    if (!room) return;
    const { subtype, text, isFake, nickname, type } = payload;

    const message = createMessage({ ...payload, textDisplayTemplate });
    const newMessages = addMessage(message, room.messages);
    const newRoomData = { messages: newMessages };
    const isConsoleOnFocus = document.hasFocus();
    const isLinkPreview = subtype === MessageSubtypes.PREVIEW;

    if (room.visited && roomId !== currentRoom && !isLinkPreview) {
      newRoomData.draftUnreadMessages = room.draftUnreadMessages + 1;
    }

    dispatch(updateRooms({
      rooms: updateItemByPropertyName(rooms, roomId, { ...newRoomData }),
    }));

    const links = findLinkOrEmail(text, regLink).links;

    if (links.length && linkPreviewEnabled && !isFake && type !== 'system') {
      dispatch(addPreviewMessage(links, message, roomId));
    }

    if (lastTimeLogin && (Date.now() - lastTimeLogin > BLOCK_NOTIFICATION_TIMEOUT) && !isConsoleOnFocus && notificationEnabled && Notification.permission === 'granted' && type === 'visitor' && !isLinkPreview) {
      const title = `${texts.notificationMsgReceived} ${nickname}`;
      const body = transformUnicode10to16(text);

      dispatch(showBrowserNotification(title, body, room.id));
    }
  }
};

export const processAddPreviewMessage = ({ dispatch, getState }) => next => action => {
  next(action);

  if (action.type === ADD_PREVIEW_MESSAGE) {
    const { payload, meta } = action;
    const { message: { clientTimestamp, type, nickname }, links } = payload;
    const { rooms } = getState().rooms;

    const messages = rooms.find(r => r.id === meta.roomId).messages;
    for (const link of links) {
      const newClientTimestamp = (parseInt(clientTimestamp, 10) + 1).toString();
      const isExist = messages.find(msg => msg.clientTimestamp === newClientTimestamp);
      if (isExist) continue;
      const isFile = isLinkToFile(link)
      if (isFile) continue

      const onPreviewDataReceived = previewData => {
        const { title, description, url, images } = previewData;
        const date = `${Date.now()}`;
        const image = images[0] || null;
        const domain = url.split('/')[2];

        dispatch(receiveMessage(
          meta.roomId,
          {
            id: date,
            title,
            description,
            image,
            url: link,
            domain,
            text: '',
            nickname,
            parentClientTimestamp: clientTimestamp,
            clientTimestamp: newClientTimestamp,
            date,
            type,
            subtype: MessageSubtypes.PREVIEW,
          },
          false,
        ));
      }

      previewRequest(window.lpvDomain, link, onPreviewDataReceived);
    }
  }
}

/* TODO: переместить в редюсеры */
export const processRemoveMessage = ({ dispatch, getState }) => next => action => {
  next(action);

  if (action.type === REMOVE_MESSAGE) {
    const { roomId, index } = action.payload;
    const { rooms } = getState().rooms;
    const currentRoom = rooms.find(room => room.id === roomId);

    if (!currentRoom) return;

    const { messages } = currentRoom;
    const updatedMessages = removeItem(messages, index);
    dispatch(updateRooms({
      rooms: updateItemByPropertyName(rooms, roomId, { messages: updatedMessages }),
    }))
  }
}

/* TODO: переместить в редюсеры */
export const processRemoveMessageById = ({ dispatch, getState }) => next => action => {
  next(action);

  if (action.type === REMOVE_MESSAGE_BY_ID) {
    const { messageId, roomId } = action.payload;
    const { rooms } = getState().rooms;
    const currentRoom = rooms.find(room => room.id === roomId);

    if (!currentRoom) return;

    const { messages } = currentRoom;
    const updatedMessages = removeItemByParam(messages, 'id', messageId);
    dispatch(updateRooms({
      rooms: updateItemByPropertyName(rooms, roomId, { messages: updatedMessages }),
    }))
  }
}

/* TODO: переместить в редюсеры */
export const processEditMessageById = ({ dispatch, getState }) => next => action => {
  next(action);

  if (action.type === EDIT_MESSAGE_BY_ID) {
    const { roomId, messageId, modCount, lastEditedTime, originalTextHtml, translatedTextHtml } = action.payload;
    const { rooms } = getState().rooms;
    const currentRoom = rooms.find(room => room.id === roomId);

    if (!currentRoom) return;

    const { messages } = currentRoom;
    const updatedMessages = updateMessage({
      messages, messageId, modCount, lastEditedTime, originalTextHtml, translatedTextHtml,
    });
    dispatch(updateRooms({
      rooms: updateItemByPropertyName(rooms, roomId, { messages: updatedMessages }),
    }))
  }
}

export const processSendMessage = ({ dispatch, getState }) => next => action => {
  next(action);

  if (action.type === SEND_MESSAGE) {
    const { meta: { roomId }, payload } = action;
    const { session: { nickname }, rooms: { rooms } } = getState();
    const clientTimestamp = `${Date.now()}`;
    const currentRoom = rooms.find(r => r.id === roomId);

    NetJsService.sendMessage(roomId, clientTimestamp, payload);

    if (currentRoom && currentRoom.status === RoomStatuses.VISITOR_CALLING) {
      dispatch(acceptCall(roomId));
    }

    const messageParams = {
      nickname,
      text: payload,
      type: 'operator',
      subtype: 'message',
      clientTimestamp,
      isFake: true,
    };

    dispatch(receiveMessage(roomId, messageParams, true));
  }
};

export const processReceiveCannedResponseTitles = ({ dispatch }) => next => action => {
  next(action);

  if (action.type === RECEIVE_CANNED_RESPONSE) {
    const { payload } = action;

    const unparsedTitles = payload;
    const cannedResponseTitles = parseCannedResponse(payload);

    dispatch(updateRooms({ cannedResponseTitles, unparsedTitles }));
  }
};

export const processTypingsChanged = ({ dispatch, getState }) => next => action => {
  next(action);

  if (action.type === TYPINGS_CHANGED) {
    const { rooms } = getState().rooms;
    const { meta, payload } = action;

    dispatch(updateRooms({
      rooms: updateItemByPropertyName(rooms, meta.roomId, { typings: payload }),
    }));
  }
}

export const processMessageChange = ({ dispatch, getState }) => next => action => {
  next(action);

  if (action.type === MESSAGE_CHANGE) {
    const { rooms, currentRoom: currentRoomId } = getState().rooms
    const currentRoom = rooms.find(room => room.id === currentRoomId)
    NetJsService.changeTyping(currentRoomId)
    if (currentRoom.status === RoomStatuses.VISITOR_CALLING) {
      dispatch(acceptCall(currentRoomId))
    }
  }
}

export const processSubmitInputArea = ({ dispatch, getState }) => next => action => {
  next(action);

  if (action.type === SUBMIT_INPUT_AREA) {
    const { rooms, currentRoom: currentRoomId } = getState().rooms
    const currentRoom = rooms.find(room => room.id === currentRoomId)
    const isEditableMessage = currentRoom.editableMessage.id
    if (isEditableMessage) {
      const messageText = currentRoom.editableMessage.text.trim()
      if (!messageText) return
      dispatch(sendEditedMessage({
        roomId: currentRoomId, messageId: currentRoom.editableMessage.id, text: messageText,
      }))
    } else {
      const messageText = currentRoom.draft.trim()
      if (!messageText) return
      dispatch(sendMessage(currentRoomId, messageText))
    }
  }
}

export const processSendEditedMessage = ({ dispatch, getState }) => next => action => {
  next(action);

  if (action.type === SEND_EDITED_MESSAGE) {
    NetJsService.editMessage(action.payload)
  }
}

export default [
  processSendMessage,
  processRemoveMessage,
  processRemoveMessageById,
  processEditMessageById,
  processTypingsChanged,
  processReceiveMessage,
  processAddPreviewMessage,
  processReceiveCannedResponseTitles,
  processMessageChange,
  processSubmitInputArea,
  processSendEditedMessage,
];
